import type { TOC } from '@ember/component/template-only'
import { SideNavProductGroup } from 'teacher-ui-client/components/side-nav/product-group'
import { MathseedsReportsAccordion } from 'teacher-ui-client/components/side-nav/maths/mathseeds-reports-accordion'

export const MathseedsProductGroup: TOC<unknown> = <template>
  <SideNavProductGroup @product="mathseeds" class="bg-ms-green-50 rounded-lg">
    <MathseedsReportsAccordion />
  </SideNavProductGroup>
</template>

export default MathseedsProductGroup
